import type { PrintInfo } from "@btnet/services-btnet/handlers/models/printInfo";

export interface IPrintInfoAPIData extends Partial<PrintInfoAPI> {}

/** Displays builder/owner/jobsite information on print pages */
export class PrintInfoAPI {
    constructor(data: IPrintInfoAPIData | PrintInfo) {
        this.address = data.address ?? "";
        this.cell = data.cell ?? "";
        this.email = data.email ?? "";
        this.fax = data.fax ?? "";
        this.name = data.name ?? "";
        this.phone = data.phone ?? "";
        this.companyAdditionalFields = data.companyAdditionalFields ?? [];
    }
    [key: string]: unknown;

    address?: string | null;
    cell?: string | null;
    email?: string | null;
    fax?: string | null;
    name: string | null;
    phone?: string | null;
    companyAdditionalFields?: string[] | null;
}
